module.exports = __webpack_public_path__ + "static/img/register.2e12ee7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/register.png
// module id = tj/Z
// module chunks = 1